import apiClient from "../core/HttpClient";
import { OccasionCollection } from "../models";

export default class OccasionCollectionService {
  url = "/OccasionCollections";

  public async getOccasionCollections(): Promise<OccasionCollection[]> {
    return await apiClient.get(this.url).then((res) => res.data);
  }

  public async getOccasionCollectionById(id: number): Promise<OccasionCollection> {
    return await apiClient.get(`${this.url}/${id}`).then((res) => res.data);
  }

  public async createOccasionCollection(model: OccasionCollection) {
    return await apiClient.post(this.url, model);
  }

  public async updateOccasionCollection(model: OccasionCollection) {
    return await apiClient.put(`${this.url}/${model.id}`, model);
  }

  public async deleteOccasionCollection(id: number) {
    return await apiClient.delete(`${this.url}/${id}`);
  }
}
